import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { G_BUTTON__field_number_slider_step_change } from '@/pages/page_generation/sidebar/primitive_number/G_BUTTON__field_number_slider_step_change';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD_PRIMITIVE__base_number } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__base_number';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_UI_FIELD_PRIMITIVE__number_slider } from './G_UI_FIELD_PRIMITIVE__number_slider';
import { G_UI_FIELD_PRIMITIVE__number_slider_range } from './G_UI_FIELD_PRIMITIVE__number_slider_range';

interface PROPS {
  field: FIELD_PRIMITIVE__base_number;
  without_header?: boolean;
}

export function G_UI_FIELD_PRIMITIVE__number({ field, without_header = false }: PROPS) {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   * IS DISABLED
   */
  function is_disabled() {
    return g_general__ui_disabled || field.meta.ui__is_readonly;
  }

  /*
   * RENDERS
   */
  function render_header() {
    if (without_header) return null;

    return (
      <G_UI_FIELD__header {...{ field }}>
        <G_BUTTON__field_number_slider_step_change {...{ field }} />
      </G_UI_FIELD__header>
    );
  }

  /*
   * HTML
   */

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_bar_line />;

  const value_range = field.meta.grid2d__is_dimension ? field.get_values_allowed() : field.get_value_range();

  return (
    <div className="flex flex-col w-full" {...{ onMouseOver, onMouseLeave }}>
      {/* HEADER */}
      {render_header()}

      {/* CONTENT */}
      <div
        className={`flex flex-row items-center justify-between gap-1
      w-full bg-component min-w-0 py-2 px-2
      ${is_disabled() ? 'opacity-50 cursor-not-allowed' : ''}
      `}
      >
        <span className="text-xs text-component-item-foreground text-right opacity-15 w-7 min-w-7">{value_range.min}</span>
        {field.meta.grid2d__is_dimension ? (
          <G_UI_FIELD_PRIMITIVE__number_slider_range {...{ field }} />
        ) : (
          <G_UI_FIELD_PRIMITIVE__number_slider {...{ field }} />
        )}
        <span className="text-xs text-component-item-foreground text-right opacity-15 w-7 min-w-7">{value_range.max}</span>
      </div>
    </div>
  );
}
